module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvYXNzZXRzLzY0YmNmZTFmMTNmY2UzOGUyZWEyNjI4MDE1N2ZmMmNlLnR0ZiI7"